<template id="progress-ring">
  <!-- <svg class="progress-ring" viewBox="-50,-50,100,100">
    <circle class="progress-ring-circle" r="46"/>
    <path class="progress-ring-ring" :d="path"/>
    <circle class="progress-ring-end" :cx="endX" :cy="endY" r="4"/>
    <text alignment-baseline="middle" text-anchor="middle">{{ text }}</text>
  </svg> -->
  <!-- <svg x="0px" y="0px" viewBox="0 0 90 90">
    <rect class="st0" width="90" height="90"/>
    <circle class="st1" cx="45" cy="45" r="40"/>
    <text class="circle-chart-percent" x="40%" y="50%" font-size="8">{{timer.minutes}}:{{timer.seconds}}</text> -->
    <!-- <path class="st2" :d="pathProgess"/> -->
    <!-- <circle class="st3" cx="45" cy="5" r="3"/> -->
<!-- </svg> -->

<div class="timer-circle d-flex justify-content-center align-items-center">
  <p class="mb-0">{{timer.minutes}}:{{timer.seconds}}</p>
</div>
</template>


<script>
import moment from "moment";

export default {
  name: "progress-ring",
  data() {
    return {
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false
      }
    };
  },
  mounted: function() {
    this.startTimer();
  },
  methods: {
    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        if (this.timer.stop == true) {
          return;
        }
        if (parseInt(this.timer.seconds) <= 0) {
          this.timer.seconds = 60;
        }
        if (
          parseInt(this.timer.seconds) <= 0 &&
          parseInt(this.timer.minutes) <= 0
        ) {
          // this.timer.seconds = 60;
          this.timer.stop = false;
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          clearTimeout(self.timerStartFunction);
          return false;
        }
        this.timer.seconds = parseInt(this.timer.seconds) - 1;
        if (this.timer.seconds < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }
      }, 1000);
      setInterval(() => {
        if (this.timer.stop == true) {
          return;
        }
        if (this.timer.minutes == 0 && this.timer.seconds == 0) {
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          //TODO Show timeout message and a redirect button
          this.timer.TimeoutModal = true;
          this.timer.minutes = 0;
          this.timer.seconds = 0;
          this.timer.stop = true;
        }
        this.timer.minutes = parseInt(this.timer.minutes) - 1;
      }, 60000);
    }
  }
};
</script>

<style>
.st0 {
  fill: #ffffff;
}
.st1 {
  fill: none;
  stroke: #b5b5b5;
  stroke-miterlimit: 10;
}
.st2 {
  fill: none;
  stroke: #408eff;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
.st3 {
  fill: #408eff;
}

body {
  font-family: sans-serif;
}

.progress-ring {
  width: 100px;
  height: 100px;
}

.progress-ring-circle {
  stroke: rgba(0, 0, 0, 0.1);
  stroke-width: 1;
  fill: none;
}

.progress-ring-ring {
  stroke: #007fff;
  stroke-width: 2;
  fill: none;
}

.progress-ring-end {
  fill: #007fff;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/progressRing.vue